export default __webpack_public_path__ + "static/media/JC.b801c5a7.svg";